import { QueryClient } from '@tanstack/react-query';

let queryClient: QueryClient | null = null;

export function getQueryClient() {
  if (!queryClient) {
    queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          staleTime: 1000 * 60, // 1 minute
          gcTime: 1000 * 60 * 5, // 5 minutes (formerly cacheTime)
          retry: 1,
          refetchOnWindowFocus: false, // Don't refetch on window focus
        },
      },
    });
  }
  return queryClient;
}

